







import {Component, Vue} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';

@Component({
  components: {

  },

})
export default class LoadingPage extends Vue {
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;

  public loading: boolean = true;

}
